import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { secondsToMinutesAndSeconds } from 'helpers/secondsToMinutesAndSeconds';

type Props = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  remaining: number;
};

const LogoutConfirmationModal = ({ open, onClose, onConfirm, remaining }: Props) => {
  const { t } = useTranslation('translation');

  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalHeader> {t('modals.areYouHere')}</ModalHeader>
      <ModalBody>
        {t('modals.loingOutCont', { remaining: secondsToMinutesAndSeconds(remaining) })}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onClose}>
          {t('navigation.LOGOUT')}
        </Button>
        <Button color="primary" onClick={onConfirm}>
          {t('modals.continue')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LogoutConfirmationModal;
